const stateKeys = {
  current: 'maintenance-current',
  history: 'maintenance-history',
  reservations: 'maintenance-reservations',
  reservationsFrom: 'maintenance-reservations-from',
  reservationsTo: 'maintenance-reservations-to',
  reservation: 'maintenance-reservation'
}

export const state = () => ({ timePeriodHourBoundaries: null })

export const mutations = {
  timePeriodHourBoundaries(state, value) {
    state.timePeriodHourBoundaries = value
  }
}

export const actions = {
  clearStorage() {
    for (let i = 0; i < stateKeys.length; i++) {
      this.$storage.removeUniversal(stateKeys[i])
    }
  },

  /* Current */
  /* ******* */
  async getCurrent({ dispatch }) {
    /* DEMO start
    console.log('Showing demo data instead of real data')
    const demo = {
      allows_book_appointment: true,
      allows_book_assistance: true,
      expected_date: '2022-11-04',
      expiration_date: '2023-02-04',
      maintenance_id: 'a3888154-7932-11ec-94d5-005056981398',
      package_id: '91f948ec-7932-11ec-a114-005056981398',
      // reservation: [],
      reservation: {
        reservation_id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        date: '2022-03-11',
        start_time: '09:00:00',
        end_time: '11:00:00',
        status: 'available'
      },
      // {
      //   reservation_id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      //   date: '2022-03-12',
      //   start_time: '09:00:00',
      //   end_time: '11:00:00',
      //   status: 'available'
      // }
      service_partner: {
        address: {
          box: null,
          city: 'Dendermonde',
          country: 'BE',
          number: '29',
          postal_code: '9200',
          province: 'East Flanders',
          street: 'Grote markt'
        },
        can_change: true,
        company_name: 'Cooling Company',
        email: 'sbmichael88+corp2@gmail.com',
        full_name: 'Michael Cooling',
        id: 'df720500-f619-11e7-be7e-005056981398',
        phone_number: '3216564987',
        website_url: null
      },
      status: 'active'
    }
    const maintenance = demo
    DEMO end */
    const maintenance = {
      ...this.$storage.getUniversal(stateKeys.current)
    }
    if (maintenance.reservation) {
      maintenance.reservation = await dispatch(
        'mapReservation',
        maintenance.reservation
      )
    }
    return maintenance
  },
  setByInstallation(_, installation) {
    if (installation.maintenance) {
      this.$storage.setUniversal(stateKeys.current, installation.maintenance)
    }
    /* const demo = [
      {
        id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        date: '2022-03-11',
        type: 'repair',
        description: 'string',
        url: 'string'
      }
    ]
    this.$storage.setUniversal(stateKeys.history, demo) */
    if (installation.repair_history) {
      this.$storage.setUniversal(stateKeys.history, installation.repair_history)
    }
  },

  /* Repair history */
  /* ************** */
  getHistoryMapped() {
    const history = this.$storage.getUniversal(stateKeys.history)
    if (!history) {
      return []
    }
    return history.map((item) => {
      return {
        suptitle: `${this.$toLongDate(
          item.date,
          null,
          this.$i18n.locale
        )} - ${this.$i18n.t(item.description)}`
      }
    })
  },

  /* Reservations */
  /* ************ */
  mapReservation(_, reservation) {
    if (reservation) {
      return {
        ...reservation,
        start_time: this.$formatDateTimeToTime(
          this.$stringToDateTime(reservation.start_time)
        ),
        end_time: this.$formatDateTimeToTime(
          this.$stringToDateTime(reservation.end_time)
        ),
        start: new Date(`${reservation.date} ${reservation.start_time}`),
        end: new Date(`${reservation.date} ${reservation.end_time}`)
      }
    }
  },
  async getReservations(
    { dispatch, state, rootState },
    { calendarDate, useStorage, basketId }
  ) {
    if (!calendarDate) {
      return []
    }

    let from = new Date(
      calendarDate.getFullYear(),
      calendarDate.getMonth() - 1,
      1
    )

    const isPwa = rootState.index
      ? rootState.index.customerPwa
      : rootState.customerPwa
    if (!isPwa && basketId) {
      // Overwrite from data and use today as date when doing the checkout flow in SBM
      const minimumDaysToAdd = 14
      const _calendarDate = new Date()
      from = new Date(
        _calendarDate.setDate(_calendarDate.getDate() + minimumDaysToAdd)
      )
    }
    const to = new Date(from)
    to.setMonth(from.getMonth() + 3)
    to.setDate(0)

    if (useStorage) {
      const storageFrom = this.$storage.getUniversal(stateKeys.reservationsFrom)
      const storageTo = this.$storage.getUniversal(stateKeys.reservationsTo)
      const storageReservations = this.$storage.getUniversal(
        stateKeys.reservations
      )
      if (
        storageFrom &&
        storageTo &&
        storageReservations &&
        storageReservations.length &&
        from.toDateString() === new Date(storageFrom).toDateString() &&
        to.toDateString() === new Date(storageTo).toDateString()
      ) {
        return await Promise.all(
          storageReservations.map(async (reservation) => {
            return await dispatch('mapReservation', reservation)
          })
        )
      }
      return []
    }

    const maintenance = await dispatch('getCurrent')
    if (!maintenance) {
      return []
    }

    const result = await this.$marlonApi.getReservations(
      basketId || maintenance.maintenance_id,
      from,
      to
    )

    if (result?.success) {
      const boundaries = state.timePeriodHourBoundaries
      const reservations = result.reservations
        .filter((reservation) => reservation.status === 'available')
        .map((reservation) => {
          const date = reservation.date.replaceAll('-', '/')
          const myReservation = {
            ...reservation,
            start: new Date(`${date} ${reservation.start_time}`),
            end: new Date(`${date} ${reservation.end_time}`)
          }
          return myReservation
        })
        .filter(
          (reservation) =>
            (reservation.start.getHours() >= boundaries.morning.start &&
              reservation.end.getHours() <= boundaries.morning.end) ||
            (reservation.start.getHours() >= boundaries.afternoon.start &&
              reservation.end.getHours() <= boundaries.afternoon.end)
        )

      this.$storage.setUniversal(stateKeys.reservations, reservations)
      this.$storage.setUniversal(stateKeys.reservationsFrom, from)
      this.$storage.setUniversal(stateKeys.reservationsTo, to)

      return reservations
    } else {
      this.$storage.removeUniversal(stateKeys.reservations)
      this.$storage.removeUniversal(stateKeys.reservationsFrom)
      this.$storage.removeUniversal(stateKeys.reservationsTo)

      return result.errors
    }
  },
  async getReservation({ dispatch }) {
    return await dispatch(
      'mapReservation',
      this.$storage.getUniversal(stateKeys.reservation)
    )
  },
  setReservation(_, reservation) {
    this.$storage.setUniversal(stateKeys.reservation, reservation)
  },
  setTimePeriodHourBoundaries({ commit }) {
    const morningStartHourDefault = 7
    const morningEndHourDefault = 12
    const afternoonStartHourDefault = 13
    const afternoonEndHourDefault = 8

    let morningStartHour = this.$i18n.t('reservationBoundaryMorningStartHour')
    let morningEndHour = this.$i18n.t('reservationBoundaryMorningEndHour')
    let afternoonStartHour = this.$i18n.t(
      'reservationBoundaryAfternoonStartHour'
    )
    let afternoonEndHour = this.$i18n.t('reservationBoundaryAfternoonEndHour')

    // 01. Check if translation is a number
    morningStartHour = isNaN(morningStartHour)
      ? morningStartHourDefault
      : parseInt(morningStartHour)
    morningEndHour = isNaN(morningEndHour)
      ? morningEndHourDefault
      : parseInt(morningEndHour)
    afternoonStartHour = isNaN(afternoonStartHour)
      ? afternoonStartHourDefault
      : parseInt(afternoonStartHour)
    afternoonEndHour = isNaN(afternoonEndHour)
      ? afternoonEndHourDefault
      : parseInt(afternoonEndHour)

    // 02. Check if mornings are indeed above afternoons, and vice versa
    morningStartHour =
      morningStartHour >= afternoonStartHour
        ? morningStartHourDefault
        : morningStartHour
    morningEndHour =
      morningEndHour > afternoonStartHour
        ? morningEndHourDefault
        : morningEndHour
    afternoonStartHour =
      afternoonStartHour < morningEndHour
        ? afternoonStartHourDefault
        : afternoonStartHour
    afternoonEndHour =
      afternoonEndHour <= morningEndHour
        ? afternoonEndHourDefault
        : afternoonEndHour

    // 03. Check if mornings are above each other. Same for afternoons
    morningStartHour =
      morningStartHour > morningEndHour
        ? morningStartHourDefault
        : morningStartHour
    morningEndHour =
      morningEndHour < morningStartHour ? morningEndHourDefault : morningEndHour
    afternoonStartHour =
      afternoonStartHour > afternoonEndHour
        ? afternoonStartHourDefault
        : afternoonStartHour
    afternoonEndHour =
      afternoonEndHour < afternoonStartHour
        ? afternoonEndHourDefault
        : afternoonEndHour

    const timePeriodHourBoundaries = {
      morning: {
        start: morningStartHour,
        end: morningEndHour,
        text: `${this.$i18n.t('morning')} ${this.$mapNumberToHour(
          morningStartHour
        )} - ${this.$mapNumberToHour(morningEndHour)}`
      },
      afternoon: {
        start: afternoonStartHour,
        end: afternoonEndHour,
        text: `${this.$i18n.t('afternoon')} ${this.$mapNumberToHour(
          afternoonStartHour
        )} - ${this.$mapNumberToHour(afternoonEndHour)}`
      }
    }

    commit('timePeriodHourBoundaries', timePeriodHourBoundaries)
  },
  async lockReservation({ dispatch }, { reservation, basketId }) {
    const maintenance = await dispatch('getCurrent')
    if (!maintenance) {
      return { success: false, errors: ['reservation_is_not_available'] }
    }

    const response = await this.$marlonApi.lockReservation(
      reservation.reservation_id,
      basketId || maintenance.maintenance_id
    )

    dispatch('setReservation', response.success ? reservation : null)

    return response
  },
  async confirmReservation(_, { reservationId, maintenanceId }) {
    return await this.$marlonApi.confirmReservation(
      reservationId,
      maintenanceId
    )
  }
}
